import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { json, Link, useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ReactQuill from "react-quill";

import {
  addEditData,
  speakersList
} from "../../controllers/trainings/trainings";
import { fetchIpAddress } from "../../controllers/API";

import LoadingEffect from "../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [image, setImage] = useState([]);
  const [bannerImage, setBannerImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ selectedSpeaker ,setSelectedSpeaker] = useState(state?.speaker || "");
  const [ DESCRIPTION, setDescription ] = useState("");
  // const [formData, setFormData] = useState({
  //   vendor_account_number: ADDEDITDATA?.vendor_account_number || "",
  // });
  const [ variantsData, setVariantsData ] = useState(ADDEDITDATA.variants || 
    [
      {
        "title": "Live & Recording",
        "price": 399,
        "status": "A"
      },
      {
        "title": "Live & DVD",
        "price": 399,
        "status": "A"
      },
      {
        "title": "Live & Flash Drive",
        "price": 399,
        "status": "A"
      },
      {
        "title": "Transcript",
        "price": 299,
        "status": "A"
      },
      {
        "title": "Recording",
        "price": 299,
        "status": "A"
      },
      {
        "title": "DVD",
        "price": 299,
        "status": "A"
      },
      {
        "title": "Flashdrive",
        "price": 299,
        "status": "A"
      },
      {
        "title": "Recording & Transcript",
        "price": 399,
        "status": "A"
      },
      {
        "title": "Flashdrive & Transcript",
        "price": 399,
        "status": "A"
      },
      {
        "title": "DVD & Transcript",
        "price": 399,
        "status": "A"
      },
      {
        "title": "Recording, DVD & Transcript",
        "price": 399,
        "status": "A"
      },
      {
        "title": "Live",
        "price": 299,
        "status": "A"
      },
      
    ]
  );
  const [ speakers , setSpeakers ] = useState([]);
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    if(e.target.name === "speaker"){
      setSelectedSpeaker(e.target.value);
    } else {
      setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
    }
  };
  /*********************************************************
   *  This function is use to handle image
   *********************************************************/  
  const  handleImageChnage = (e) => {
    const fileList = e.fileList.slice(-1); // Keep only the last image
    setImage(fileList);
    if (fileList.length === 0) {
        setError(prev => ({ ...prev, image: "Image is required." }));
    } else {
        setError(prev => ({ ...prev, image: "" }));
    }
};

 const handleBannerImageChange = (e) => {
      const fileList = e.fileList.slice(-1);
      setBannerImage(fileList);
      setError(prev => ({
          ...prev,
          banner_image: ""
      }));
  };


  const handleNestedChange = (index, field, value) => {
  const updatedVariants = [...variantsData];
  updatedVariants[index][field] = value;
  setVariantsData(updatedVariants);
  console.log('variantsData', updatedVariants);
};

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        title,
        date,
        time,
        isOndemand,
        duration,
        category
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      } 
      form.append("title", title);
      form.append("description", DESCRIPTION);
      form.append("speaker", selectedSpeaker);
      form.append("date", date);
      form.append("time", time); 
      form.append("isOndemand", isOndemand);
      form.append("duration", duration);
      form.append("category", category);
      form.append("variants", JSON.stringify(variantsData));
      if (image.length > 0) {
        form.append("image", image[0]?.originFileObj);
      }
      if (bannerImage.length > 0) {
          form.append("banner_image", bannerImage[0]?.originFileObj);
      }
      
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
// console.log('isValidate',isValidate);
      if (isValidate) {
        const options = {
          url: "trainings/addeditdata",
          postData: form,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated.",
            description: `Data updated Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/trainings/list");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    }finally{
      setIsLoading(false);
    }
  };


  // const validateFormData = (form) => {
  //   if (!form.get("title") || form.get("title") === "undefined" || form.get("title") === null) {
  //     notification.error({
  //       message: "Validation Error",
  //       description: "Title is required",
  //     });
  //     return false;
  //   }

  //   if (!form.get("description") ||  form.get("description") === "undefined" || form.get("description") === null) {
  //     notification.error({
  //       message: "Validation Error",
  //       description: "Description is required",
  //     });
  //     return false;
  //   }
  //   if (!form.get("speaker") ||  form.get("speaker") === "undefined" || form.get("speaker") === null) {
  //     notification.error({
  //       message: "Validation Error",
  //       description: "Speaker is required",
  //     });
  //     return false;
  //   }
  //   if (!form.get("date") ||  form.get("date") === "undefined" || form.get("date") === null) {
  //     notification.error({
  //       message: "Validation Error",
  //       description: "Date is required",
  //     });
  //     return false;
  //   }
  //   if (!form.get("duration") ||  form.get("duration") === "undefined" || form.get("duration") === null) {
  //     notification.error({
  //       message: "Validation Error",
  //       description: "Duration is required",
  //     });
  //     return false;
  //   }
  //   return true;
  // };


const validateFormData = (form) => {
  const isEmpty = (value) => {
    return (
      value === undefined ||
      value === null ||
      value === "" ||
      value === "undefined" ||
      (typeof value === "string" && value.trim() === "")
    );
  };

  // Title
  if (isEmpty(form.get("title"))) {
    notification.error({
      message: "Validation Error",
      description: "Title is required",
    });
    return false;
  }

  // Description
  if (isEmpty(form.get("description")) || form.get("description") === "<p><br></p>") {
    notification.error({
      message: "Validation Error",
      description: "Description is required",
    });
    return false;
  }

  // Speaker
  if (isEmpty(form.get("speaker"))) {
    notification.error({
      message: "Validation Error",
      description: "Speaker is required",
    });
    return false;
  }

  // Date
  if (isEmpty(form.get("date"))) {
    notification.error({
      message: "Validation Error",
      description: "Date is required",
    });
    return false;
  }

  // Time
  if (isEmpty(form.get("time"))) {
    notification.error({
      message: "Validation Error",
      description: "Time is required",
    });
    return false;
  }

  // Duration
  if (isEmpty(form.get("duration"))) {
    notification.error({
      message: "Validation Error",
      description: "Duration is required",
    });
    return false;
  }

  // Category
  if (isEmpty(form.get("category"))) {
    notification.error({
      message: "Validation Error",
      description: "Category is required",
    });
    return false;
  }

  // Image
  // Required only when adding a new training.
  // During edit, the existing image can remain unchanged.
  if (!ADDEDITDATA?._id && image.length === 0) {
    notification.error({
      message: "Validation Error",
      description: "Image is required",
    });
    return false;
  }

  // Variants
  if (!variantsData || variantsData.length === 0) {
    notification.error({
      message: "Validation Error",
      description: "At least one variant is required",
    });
    return false;
  }

  for (let i = 0; i < variantsData.length; i++) {
    const variant = variantsData[i];

    if (
      variant.title === undefined ||
      variant.title === null ||
      String(variant.title).trim() === ""
    ) {
      notification.error({
        message: "Validation Error",
        description: `Variant ${i + 1} title is required`,
      });
      return false;
    }

    if (
      variant.price === undefined ||
      variant.price === null ||
      variant.price === "" ||
      String(variant.price).trim() === ""
    ) {
      notification.error({
        message: "Validation Error",
        description: `Variant ${i + 1} price is required`,
      });
      return false;
    }

    if (
      variant.status === undefined ||
      variant.status === null ||
      variant.status === ""
    ) {
      notification.error({
        message: "Validation Error",
        description: `Variant ${i + 1} status is required`,
      });
      return false;
    }
  }

  // banner_image intentionally NOT validated.
  // It is optional.

  return true;
};

  /*********************************************************
     *  This function is use to get speakers list
     *********************************************************/
    const getSpeakersList = async () => {
      setSpeakers([]);
      const options = {
        type: "",
        condition: {},
        select: {},
        sort: { _id: -1 }
      };
      const speakerListData = await speakersList(options);
      if (speakerListData.status === true) {
        setSpeakers(speakerListData?.result);
      } else {
        setSpeakers([]);
      }
    }; //End


  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    getSpeakersList();
    if(ADDEDITDATA._id){
      setDescription(ADDEDITDATA.description);
      setSelectedSpeaker(ADDEDITDATA.speaker._id);
    }
    document.title = `CompliancesWebinar || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Training`;
  }, []);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Training
            </h5>
          </div>
          <Link to="/trainings/list">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  <div className="row">
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="vendor_first_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Title :{" "}
                      </label>
                      <input
                        title="Enter Title."
                        placeholder="Enter Title."
                        type="text"
                        name="title"
                        className="form-control store_input_field"
                        id="title"
                        value={ADDEDITDATA?.title}
                        onChange={handleChange}
                      />
                      {error.title ? (
                        <p style={{ color: "red" }}>
                          {error.title}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-12 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="vendor_email"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Description :
                      </label>
                      <div className="term_and_condation_react_quilllll">
                        <ReactQuill
                          theme="snow"
                          modules={{
                            toolbar: [
                              [{ header: [1, 2, 3, 4, 5, false] }],
                              [
                                "bold",
                                "italic",
                                "underline",
                                "strike",
                                "blockquote",
                              ],
                              [
                                { list: "ordered" },
                                { list: "bullet" },
                                { indent: "-1" },
                                { indent: "+1" },
                              ],
                              ["link", "image"],
                              ["clean"],
                            ],
                          }}
                          formats={[
                            "header",
                            "bold",
                            "italic",
                            "underline",
                            "strike",
                            "blockquote",
                            "list",
                            "bullet",
                            "indent",
                            "link",
                            "image",
                          ]}
                          value={DESCRIPTION || ""}
                          onChange={setDescription}
                        />
                      </div>
                      {error.description ? (
                        <p style={{ color: "red" }}>{error.description}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div class="form-group col-6">
                    <label
                      for="speaker"
                      className="all_vendor_radio_button_div"
                    >
                      Select Speaker
                    </label>
                    <select
                      name="speaker"
                      id="speaker"
                      className="form-control categories_select_tg_enter_product"
                      onChange={handleChange}
                      value={selectedSpeaker || ""}
                    >
                      <option value="">Select Speaker</option>
                      {speakers.map((speaker, speakerIndex) => (
                        <option key={speakerIndex} value={speaker._id}>{speaker?.title}</option>
                      ))}
                    </select>
                    {error?.speaker ? (
                      <p style={{ color: "red" }}>{error.speaker}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div class="form-group col-6">
                    <label
                      for="categoryId"
                      className="all_vendor_radio_button_div"
                    >
                      Duration
                    </label>
                    <input
                      type="text"
                      name="duration"
                      className="form-control categories_select_tg_enter_product"
                      id="duration"
                      value={ADDEDITDATA?.duration}
                      onChange={handleChange}
                    />
                    {error?.duration ? (
                      <p style={{ color: "red" }}>{error.duration}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div class="form-group col-4">
                    <label
                      for="categoryId"
                      className="all_vendor_radio_button_div"
                    >
                      Date
                    </label>
                    <input
                      type="date"
                      name="date"
                      className="form-control categories_select_tg_enter_product"
                      id="date"
                      value={ADDEDITDATA?.date}
                      onChange={handleChange}
                    />
                    {error?.date ? (
                      <p style={{ color: "red" }}>{error.date}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div class="form-group col-4">
                    <label
                      for="categoryId"
                      className="all_vendor_radio_button_div"
                    >
                      Time
                    </label>
                    <input
                      type="time"
                      name="time"
                      className="form-control categories_select_tg_enter_product"
                      id="time"
                      value={ADDEDITDATA?.time}
                      onChange={handleChange}
                    />
                    {error?.time ? (
                      <p style={{ color: "red" }}>{error.time}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-6-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                      Mark as On-demand :{" "}
                    </label>
                    <select
                      name="isOndemand"
                      id="isOndemand"
                      className="form-control categories_select_tg_enter_product"
                      value={ADDEDITDATA.isOndemand}
                      onChange={handleChange}
                    >
                      <option value="N">No</option>
                      <option value="Y">Yes</option>
                    </select>
                  </div>
                  <div className="form-group col-lg-6 col-md-6-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                      <span style={{ color: "red" }}>*</span>Select category :{" "}
                    </label>
                    <select
                      name="category"
                      id="category"
                      className="form-control categories_select_tg_enter_product"
                      value={ADDEDITDATA.category}
                      onChange={handleChange}
                    >
                      <option value="">Select category</option>
                      <option value="Manufacturing">Manufacturing</option>
                      <option value="Bundle Webinar">Bundle Webinar</option>
                      <option value="Construction">Construction</option>
                      <option value="Finance">Finance</option>
                      <option value="Healthcare">Healthcare</option>
                      <option value="Housing">Housing</option>
                      <option value="HR">HR</option>
                      <option value="IT">IT</option>
                      <option value="On demand">On demand</option>
                    </select>
                  </div>
                  </div> 
                </div>

                {/* -------------------------------------------------------- */}
                {variantsData.map((variant, variantIndex) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={variantIndex}>
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-4-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Variant title :{" "}
                          </label>
                          <input
                            placeholder="Title"
                            value={variant.title}
                            onChange={(e) =>
                              handleNestedChange(variantIndex, "title", e.target.value, "variants")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Price :{" "}
                          </label>
                          <input
                            placeholder="Price"
                            value={variant.price}
                            onChange={(e) =>
                              handleNestedChange(variantIndex, "price", e.target.value, "variants")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test type :{" "}
                          </label>
                          <select
                            name="status"
                            id="status"
                            className="form-control categories_select_tg_enter_product"
                            // onChange={handleChange}
                            // value={selectedSpeaker || ""}
                            value={variant.status}
                            onChange={(e) =>
                              handleNestedChange(variantIndex, "status", e.target.value, "variants")
                            }
                          >
                            <option value="A">Active</option>
                            <option value="I">Inactive</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  ))}
                {/* -------------------------------------------------------- */}

                <div className="form-group">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="all_section_for_label_main_class"
                  >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Images
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="1"
                    // listType="picture"
                    onChange={handleImageChnage}
                    beforeUpload={beforeUpload}
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload file
                    </button>
                  </Dragger>
                  {/* <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an image format (JPEG/JPG/PNG) and
                    ensure its dimensions are 420px x 280px.
                  </p> */}
                  {error.image ? (
                    <p style={{ color: "red" }}>{error.image}</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="form-group">
                    <label
                        htmlFor="banner_image"
                        className="all_section_for_label_main_class"
                    >
                        Banner Image
                    </label>

                    <Dragger
                        className="about_us_dragger_file"
                        maxCount={1}
                        onChange={handleBannerImageChange}
                        beforeUpload={beforeUpload}
                    >
                        <button
                            type="button"
                            className="about_us_dragger_file_button"
                        >
                            Upload Banner Image
                        </button>
                    </Dragger>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
